import { NotificationTemplate } from "../index";

export const TaxPending: NotificationTemplate<never> = {
  renderTitle: () => "Tax identity verification in progress",
  renderBody: () =>
    "We've received your information and our team is currently reviewing it. This process typically takes less than one business day. Thank you for your patience."
};
